import { render, staticRenderFns } from "./logModal.vue?vue&type=template&id=f8c9b9bc&scoped=true&"
import script from "./logModal.vue?vue&type=script&lang=ts&"
export * from "./logModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c9b9bc",
  null
  
)

export default component.exports